/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ActiveOrdersRequest,
  ActiveOrdersResponse,
  ArtworkLink,
  ArtworkMatchFilesRequest,
  ArtworkMatchFilesResponse,
  ArtworkPreviewApprovalsRequest,
  ArtworkPreviewApprovalWorklistResponse,
  AttachmentFilesRequest,
  AttachmentResponse,
  AuditResponse,
  CampaignMonitorPicturesRequest,
  CampaignMonitorPicturesResponse,
  CommentAddAttachmentRequest,
  CommentMessageRequest,
  CommentRequestDataWithFiles,
  CommentResponse,
  DeploymentDashboardResponse,
  GenerateAwbRequest,
  GenerateAwbResponse,
  JourneyProgressRequest,
  JourneyProgressResponse,
  LocationCommentsResponse,
  MultiJourneyProgressResponse,
  OrderCommentsRequest,
  PageResponseServiceResponse,
  PageResponseServiceTaskResponse,
  PageResponseSupplierResponse,
  PageResponseSupplierUserResponse,
  PageResponseUserInfo,
  ServiceRequest,
  ServiceResponse,
  ServicesRequest,
  ServiceTaskDocumentsRequest,
  ServiceTaskDocumentsResponse,
  ServiceTaskFilterResponse,
  ServiceTaskResponse,
  ServiceViewRequest,
  ServiceViewResponse,
  ShipmentResponse,
  SupplierDetailResponse,
  SupplierListRequest,
  SupplierRequest,
  TaskGetRequest,
  TodoResponse,
  UpdateBookingMatchGeometryRequest,
  UpdateJourneyProgressRequest,
  UpdateTaskRequest,
  UpdateTaskTeamRequest,
  UsersRequest,
  VisualResourcesRequest,
  VisualResourcesResponse,
  WeatherRequest,
  WeatherResponse,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Services<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags service-controller
   * @name AddService
   * @request POST:/services
   * @secure
   * @response `200` `ServiceResponse` OK
   */
  addService = (data: ServiceRequest, params: RequestParams = {}) =>
    this.request<ServiceResponse, any>({
      path: `/services`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-view-controller
   * @name AddView
   * @request POST:/services/views
   * @secure
   * @response `200` `ServiceViewResponse` OK
   */
  addView = (data: ServiceViewRequest, params: RequestParams = {}) =>
    this.request<ServiceViewResponse, any>({
      path: `/services/views`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags task-shipment-controller
   * @name ListTaskShipments
   * @summary The task's AWBs, for the journey card
   * @request GET:/services/tasks/{taskId}/shipments
   * @secure
   * @response `200` `(ShipmentResponse)[]` OK
   */
  listTaskShipments = (taskId: string, params: RequestParams = {}) =>
    this.request<ShipmentResponse[], any>({
      path: `/services/tasks/${taskId}/shipments`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags task-shipment-controller
   * @name GenerateAwb
   * @summary Generate an AWB for this print task
   * @request POST:/services/tasks/{taskId}/shipments
   * @secure
   * @response `200` `GenerateAwbResponse` OK
   */
  generateAwb = (
    taskId: string,
    data: GenerateAwbRequest,
    params: RequestParams = {},
  ) =>
    this.request<GenerateAwbResponse, any>({
      path: `/services/tasks/${taskId}/shipments`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-task-controller
   * @name GetServiceTaskDocuments
   * @request GET:/services/tasks/{taskId}/documents
   * @secure
   * @response `200` `ServiceTaskDocumentsResponse` OK
   */
  getServiceTaskDocuments = (taskId: string, params: RequestParams = {}) =>
    this.request<ServiceTaskDocumentsResponse, any>({
      path: `/services/tasks/${taskId}/documents`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags service-task-controller
   * @name UploadServiceTaskDocuments
   * @request POST:/services/tasks/{taskId}/documents
   * @secure
   * @response `200` `ServiceTaskDocumentsResponse` OK
   */
  uploadServiceTaskDocuments = (
    taskId: string,
    data: ServiceTaskDocumentsRequest,
    params: RequestParams = {},
  ) =>
    this.request<ServiceTaskDocumentsResponse, any>({
      path: `/services/tasks/${taskId}/documents`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-task-controller
   * @name GetServiceTaskComments
   * @request GET:/services/tasks/{taskId}/comments
   * @secure
   * @response `200` `Record<string,(CommentResponse)[]>` OK
   */
  getServiceTaskComments = (taskId: string, params: RequestParams = {}) =>
    this.request<Record<string, CommentResponse[]>, any>({
      path: `/services/tasks/${taskId}/comments`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-task-controller
   * @name AddServiceTaskComment
   * @request POST:/services/tasks/{taskId}/comments
   * @secure
   * @response `200` `CommentResponse` OK
   */
  addServiceTaskComment = (
    taskId: string,
    data: CommentRequestDataWithFiles,
    params: RequestParams = {},
  ) =>
    this.request<CommentResponse, any>({
      path: `/services/tasks/${taskId}/comments`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-task-controller
   * @name DeleteServiceTaskCommentAttachments
   * @request POST:/services/tasks/{taskId}/comments/{commentId}/deleteAttachments
   * @secure
   * @response `200` `CommentResponse` OK
   */
  deleteServiceTaskCommentAttachments = (
    taskId: string,
    commentId: string,
    data: CommentAddAttachmentRequest,
    params: RequestParams = {},
  ) =>
    this.request<CommentResponse, any>({
      path: `/services/tasks/${taskId}/comments/${commentId}/deleteAttachments`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-task-controller
   * @name AddServiceTaskCommentAttachments
   * @request POST:/services/tasks/{taskId}/comments/{commentId}/attachments
   * @secure
   * @response `200` `CommentResponse` OK
   */
  addServiceTaskCommentAttachments = (
    taskId: string,
    commentId: string,
    data: CommentAddAttachmentRequest,
    params: RequestParams = {},
  ) =>
    this.request<CommentResponse, any>({
      path: `/services/tasks/${taskId}/comments/${commentId}/attachments`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-task-controller
   * @name GetCampaignMonitor
   * @request GET:/services/tasks/{taskId}/campaignMonitor
   * @secure
   * @response `200` `CampaignMonitorPicturesResponse` OK
   */
  getCampaignMonitor = (taskId: string, params: RequestParams = {}) =>
    this.request<CampaignMonitorPicturesResponse, any>({
      path: `/services/tasks/${taskId}/campaignMonitor`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags service-task-controller
   * @name UpdateCampaignMonitorImages
   * @request POST:/services/tasks/{taskId}/campaignMonitor
   * @secure
   * @response `200` `CampaignMonitorPicturesResponse` OK
   */
  updateCampaignMonitorImages = (
    taskId: string,
    data: CampaignMonitorPicturesRequest,
    params: RequestParams = {},
  ) =>
    this.request<CampaignMonitorPicturesResponse, any>({
      path: `/services/tasks/${taskId}/campaignMonitor`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-task-controller
   * @name UploadArtwork
   * @request POST:/services/tasks/{taskId}/artwork
   * @secure
   * @response `200` `ServiceTaskResponse` OK
   */
  uploadArtwork = (
    taskId: string,
    data: {
      files: File[];
    },
    query?: {
      operationId?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<ServiceTaskResponse, any>({
      path: `/services/tasks/${taskId}/artwork`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-task-controller
   * @name UploadArtworkPreview
   * @request POST:/services/tasks/{taskId}/artworkPreview
   * @secure
   * @response `200` `ServiceTaskResponse` OK
   */
  uploadArtworkPreview = (
    taskId: string,
    data: {
      files: File[];
    },
    query?: {
      operationId?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<ServiceTaskResponse, any>({
      path: `/services/tasks/${taskId}/artworkPreview`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-task-controller
   * @name UpdateServiceTaskArtworkPreviewVersion
   * @summary Update Service Task Artwork Preview Version
   * @request POST:/services/tasks/{taskId}/artworkPreview/{attachmentId}
   * @secure
   * @response `200` `AttachmentResponse` OK
   */
  updateServiceTaskArtworkPreviewVersion = (
    taskId: string,
    attachmentId: string,
    data: AttachmentFilesRequest,
    params: RequestParams = {},
  ) =>
    this.request<AttachmentResponse, any>({
      path: `/services/tasks/${taskId}/artworkPreview/${attachmentId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-task-controller
   * @name GetArtworkMatch
   * @request GET:/services/tasks/{taskId}/artworkMatch
   * @secure
   * @response `200` `ArtworkMatchFilesResponse` OK
   */
  getArtworkMatch = (taskId: string, params: RequestParams = {}) =>
    this.request<ArtworkMatchFilesResponse, any>({
      path: `/services/tasks/${taskId}/artworkMatch`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags service-task-controller
   * @name UpdateArtworkMatchFile
   * @request POST:/services/tasks/{taskId}/artworkMatch
   * @secure
   * @response `200` `ArtworkMatchFilesResponse` OK
   */
  updateArtworkMatchFile = (
    taskId: string,
    data: ArtworkMatchFilesRequest,
    params: RequestParams = {},
  ) =>
    this.request<ArtworkMatchFilesResponse, any>({
      path: `/services/tasks/${taskId}/artworkMatch`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-task-controller
   * @name GetServiceTaskArtworkGeometry
   * @summary Get Service Task Artwork Geometry
   * @request GET:/services/tasks/{taskId}/artworkGeometry
   * @secure
   * @response `200` `string` OK
   */
  getServiceTaskArtworkGeometry = (
    taskId: string,
    params: RequestParams = {},
  ) =>
    this.request<string, any>({
      path: `/services/tasks/${taskId}/artworkGeometry`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-task-controller
   * @name UpdateServiceTaskArtworkGeometry
   * @summary Update Service Task Artwork Geometry
   * @request POST:/services/tasks/{taskId}/artworkGeometry
   * @secure
   * @response `200` `string` OK
   */
  updateServiceTaskArtworkGeometry = (
    taskId: string,
    data: string,
    params: RequestParams = {},
  ) =>
    this.request<string, any>({
      path: `/services/tasks/${taskId}/artworkGeometry`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-task-controller
   * @name GetServiceTasksWeather
   * @summary Get weather forecast and badge for service tasks
   * @request POST:/services/tasks/weather
   * @secure
   * @response `200` `WeatherResponse` OK
   */
  getServiceTasksWeather = (data: WeatherRequest, params: RequestParams = {}) =>
    this.request<WeatherResponse, any>({
      path: `/services/tasks/weather`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags service-task-controller
   * @name GetJourneyProgress
   * @summary Get Journey Progress for multiple tasks
   * @request POST:/services/tasks/journey
   * @secure
   * @response `200` `MultiJourneyProgressResponse` OK
   */
  getJourneyProgress = (
    data: JourneyProgressRequest,
    params: RequestParams = {},
  ) =>
    this.request<MultiJourneyProgressResponse, any>({
      path: `/services/tasks/journey`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags service-task-controller
   * @name GetTasksForServices
   * @request POST:/services/tasks/getServicesTasks
   * @secure
   * @response `200` `PageResponseServiceTaskResponse` OK
   */
  getTasksForServices = (data: TaskGetRequest, params: RequestParams = {}) =>
    this.request<PageResponseServiceTaskResponse, any>({
      path: `/services/tasks/getServicesTasks`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-task-controller
   * @name GetCampaignComments
   * @request POST:/services/tasks/getComments/{orderId}
   * @secure
   * @response `200` `(LocationCommentsResponse)[]` OK
   */
  getCampaignComments = (
    orderId: string,
    data: OrderCommentsRequest,
    params: RequestParams = {},
  ) =>
    this.request<LocationCommentsResponse[], any>({
      path: `/services/tasks/getComments/${orderId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-task-controller
   * @name DeleteCampaignCommentAttachments
   * @request POST:/services/tasks/comments/deleteAttachments/{commentId}
   * @secure
   * @response `200` `CommentResponse` OK
   */
  deleteCampaignCommentAttachments = (
    commentId: string,
    data: CommentAddAttachmentRequest,
    params: RequestParams = {},
  ) =>
    this.request<CommentResponse, any>({
      path: `/services/tasks/comments/deleteAttachments/${commentId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-task-controller
   * @name AddCampaignCommentAttachments
   * @request POST:/services/tasks/comments/addAttachments/{commentId}
   * @secure
   * @response `200` `CommentResponse` OK
   */
  addCampaignCommentAttachments = (
    commentId: string,
    data: CommentAddAttachmentRequest,
    params: RequestParams = {},
  ) =>
    this.request<CommentResponse, any>({
      path: `/services/tasks/comments/addAttachments/${commentId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-task-controller
   * @name AddCampaignComment
   * @request POST:/services/tasks/campaignComments/{orderId}
   * @secure
   * @response `200` `CommentResponse` OK
   */
  addCampaignComment = (
    orderId: string,
    data: CommentRequestDataWithFiles,
    params: RequestParams = {},
  ) =>
    this.request<CommentResponse, any>({
      path: `/services/tasks/campaignComments/${orderId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-task-controller
   * @name GetCampaignCommentUsers
   * @request POST:/services/tasks/campaignComments/{orderId}/users/{locationId}
   * @secure
   * @response `200` `PageResponseUserInfo` OK
   */
  getCampaignCommentUsers = (
    orderId: string,
    locationId: string,
    data: UsersRequest,
    params: RequestParams = {},
  ) =>
    this.request<PageResponseUserInfo, any>({
      path: `/services/tasks/campaignComments/${orderId}/users/${locationId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-task-controller
   * @name GetArtworkPreviewApprovalsByOrderNumber
   * @summary Get Artwork Preview Approvals by Order Number
   * @request POST:/services/tasks/artworkPreview/approvals
   * @secure
   * @response `200` `(ArtworkPreviewApprovalWorklistResponse)[]` OK
   */
  getArtworkPreviewApprovalsByOrderNumber = (
    data: ArtworkPreviewApprovalsRequest,
    params: RequestParams = {},
  ) =>
    this.request<ArtworkPreviewApprovalWorklistResponse[], any>({
      path: `/services/tasks/artworkPreview/approvals`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags supplier-controller
   * @name CreateSupplier
   * @request POST:/services/suppliers
   * @secure
   * @response `200` `SupplierDetailResponse` OK
   */
  createSupplier = (data: SupplierRequest, params: RequestParams = {}) =>
    this.request<SupplierDetailResponse, any>({
      path: `/services/suppliers`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags supplier-controller
   * @name ListUsersForSupplier
   * @request POST:/services/suppliers/{supplierId}/getUsers
   * @secure
   * @response `200` `PageResponseSupplierUserResponse` OK
   */
  listUsersForSupplier = (
    supplierId: string,
    data: UsersRequest,
    params: RequestParams = {},
  ) =>
    this.request<PageResponseSupplierUserResponse, any>({
      path: `/services/suppliers/${supplierId}/getUsers`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags supplier-controller
   * @name ListSuppliers
   * @request POST:/services/suppliers/getSuppliers
   * @secure
   * @response `200` `PageResponseSupplierResponse` OK
   */
  listSuppliers = (data: SupplierListRequest, params: RequestParams = {}) =>
    this.request<PageResponseSupplierResponse, any>({
      path: `/services/suppliers/getSuppliers`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-controller
   * @name ListServices
   * @request POST:/services/getServices
   * @secure
   * @response `200` `PageResponseServiceResponse` OK
   */
  listServices = (data: ServicesRequest, params: RequestParams = {}) =>
    this.request<PageResponseServiceResponse, any>({
      path: `/services/getServices`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags deployment-dashboard-controller
   * @name GetDeploymentDashboardActiveOrders
   * @summary Which of the given order numbers or ids still have a service task that is not cancelled
   * @request POST:/services/dashboard/deployment/active-orders
   * @secure
   * @response `200` `ActiveOrdersResponse` OK
   */
  getDeploymentDashboardActiveOrders = (
    data: ActiveOrdersRequest,
    params: RequestParams = {},
  ) =>
    this.request<ActiveOrdersResponse, any>({
      path: `/services/dashboard/deployment/active-orders`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags service-controller
   * @name GetServiceById
   * @summary Get Service by ID
   * @request GET:/services/{serviceId}
   * @secure
   * @response `200` `ServiceResponse` OK
   */
  getServiceById = (serviceId: string, params: RequestParams = {}) =>
    this.request<ServiceResponse, any>({
      path: `/services/${serviceId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-controller
   * @name DeleteService
   * @request DELETE:/services/{serviceId}
   * @secure
   * @response `200` `ServiceResponse` OK
   */
  deleteService = (serviceId: string, params: RequestParams = {}) =>
    this.request<ServiceResponse, any>({
      path: `/services/${serviceId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-controller
   * @name UpdateService
   * @request PATCH:/services/{serviceId}
   * @secure
   * @response `200` `ServiceResponse` OK
   */
  updateService = (
    serviceId: string,
    data: ServiceRequest,
    params: RequestParams = {},
  ) =>
    this.request<ServiceResponse, any>({
      path: `/services/${serviceId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-view-controller
   * @name DeleteView
   * @request DELETE:/services/views/{serviceId}
   * @secure
   * @response `200` `ServiceViewResponse` OK
   */
  deleteView = (serviceId: string, params: RequestParams = {}) =>
    this.request<ServiceViewResponse, any>({
      path: `/services/views/${serviceId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-view-controller
   * @name UpdateView
   * @request PATCH:/services/views/{serviceId}
   * @secure
   * @response `200` `ServiceViewResponse` OK
   */
  updateView = (
    serviceId: string,
    data: ServiceViewRequest,
    params: RequestParams = {},
  ) =>
    this.request<ServiceViewResponse, any>({
      path: `/services/views/${serviceId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-view-controller
   * @name UpdateViewPosition
   * @request PATCH:/services/views/positions
   * @secure
   * @response `200` `(ServiceViewResponse)[]` OK
   */
  updateViewPosition = (
    data: Record<string, number>,
    params: RequestParams = {},
  ) =>
    this.request<ServiceViewResponse[], any>({
      path: `/services/views/positions`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-task-controller
   * @name GetServiceTask
   * @request GET:/services/tasks/{taskId}
   * @secure
   * @response `200` `ServiceTaskResponse` OK
   */
  getServiceTask = (taskId: string, params: RequestParams = {}) =>
    this.request<ServiceTaskResponse, any>({
      path: `/services/tasks/${taskId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags service-task-controller
   * @name UpdateServiceTask
   * @summary Update Service Task
   * @request PATCH:/services/tasks/{taskId}
   * @secure
   * @response `200` `ServiceTaskResponse` OK
   */
  updateServiceTask = (
    taskId: string,
    data: UpdateTaskRequest,
    params: RequestParams = {},
  ) =>
    this.request<ServiceTaskResponse, any>({
      path: `/services/tasks/${taskId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-task-controller
   * @name GetVisualResources
   * @request GET:/services/tasks/{taskId}/visualResources
   * @secure
   * @response `200` `VisualResourcesResponse` OK
   */
  getVisualResources = (taskId: string, params: RequestParams = {}) =>
    this.request<VisualResourcesResponse, any>({
      path: `/services/tasks/${taskId}/visualResources`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags service-task-controller
   * @name PatchVisualResources
   * @request PATCH:/services/tasks/{taskId}/visualResources
   * @secure
   * @response `200` `VisualResourcesResponse` OK
   */
  patchVisualResources = (
    taskId: string,
    data: VisualResourcesRequest,
    params: RequestParams = {},
  ) =>
    this.request<VisualResourcesResponse, any>({
      path: `/services/tasks/${taskId}/visualResources`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-task-controller
   * @name UpdateServiceTaskTeam
   * @summary Update Service Task Team
   * @request PATCH:/services/tasks/{taskId}/team
   * @secure
   * @response `200` `ServiceTaskResponse` OK
   */
  updateServiceTaskTeam = (
    taskId: string,
    data: UpdateTaskTeamRequest,
    params: RequestParams = {},
  ) =>
    this.request<ServiceTaskResponse, any>({
      path: `/services/tasks/${taskId}/team`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-task-controller
   * @name UpdateJourneyProgress
   * @summary Update Journey Progress
   * @request PATCH:/services/tasks/{taskId}/journey
   * @secure
   * @response `200` `JourneyProgressResponse` OK
   */
  updateJourneyProgress = (
    taskId: string,
    data: UpdateJourneyProgressRequest,
    params: RequestParams = {},
  ) =>
    this.request<JourneyProgressResponse, any>({
      path: `/services/tasks/${taskId}/journey`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-task-controller
   * @name GetServiceTaskBookingGeometry
   * @summary Get Service Task Booking Geometry
   * @request GET:/services/tasks/{taskId}/geometry
   * @secure
   * @response `200` `string` OK
   */
  getServiceTaskBookingGeometry = (
    taskId: string,
    params: RequestParams = {},
  ) =>
    this.request<string, any>({
      path: `/services/tasks/${taskId}/geometry`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-task-controller
   * @name UpdateServiceTaskBookingGeometry
   * @summary Update Service Task Booking Geometry
   * @request PATCH:/services/tasks/{taskId}/geometry
   * @secure
   * @response `200` `string` OK
   */
  updateServiceTaskBookingGeometry = (
    taskId: string,
    data: UpdateBookingMatchGeometryRequest,
    params: RequestParams = {},
  ) =>
    this.request<string, any>({
      path: `/services/tasks/${taskId}/geometry`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-task-controller
   * @name DeleteServiceTaskComment
   * @request DELETE:/services/tasks/{taskId}/comments/{commentId}
   * @secure
   * @response `200` `void` OK
   */
  deleteServiceTaskComment = (
    taskId: string,
    commentId: string,
    params: RequestParams = {},
  ) =>
    this.request<void, any>({
      path: `/services/tasks/${taskId}/comments/${commentId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-task-controller
   * @name UpdateServiceTaskComment
   * @request PATCH:/services/tasks/{taskId}/comments/{commentId}
   * @secure
   * @response `200` `CommentResponse` OK
   */
  updateServiceTaskComment = (
    taskId: string,
    commentId: string,
    data: CommentMessageRequest,
    params: RequestParams = {},
  ) =>
    this.request<CommentResponse, any>({
      path: `/services/tasks/${taskId}/comments/${commentId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-task-controller
   * @name PromoteServiceTaskArtworkPreviewVersion
   * @summary Promote Service Task Artwork Preview Version
   * @request PATCH:/services/tasks/{taskId}/artworkPreview/{attachmentId}/versions/{versionId}/current
   * @secure
   * @response `200` `AttachmentResponse` OK
   */
  promoteServiceTaskArtworkPreviewVersion = (
    taskId: string,
    attachmentId: string,
    versionId: number,
    params: RequestParams = {},
  ) =>
    this.request<AttachmentResponse, any>({
      path: `/services/tasks/${taskId}/artworkPreview/${attachmentId}/versions/${versionId}/current`,
      method: "PATCH",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-task-controller
   * @name UpdateArtWorkLinks
   * @request PATCH:/services/tasks/{taskId}/artworkLinks
   * @secure
   * @response `200` `ServiceTaskResponse` OK
   */
  updateArtWorkLinks = (
    taskId: string,
    data: ArtworkLink[],
    params: RequestParams = {},
  ) =>
    this.request<ServiceTaskResponse, any>({
      path: `/services/tasks/${taskId}/artworkLinks`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-task-controller
   * @name DeleteCampaignComment
   * @request DELETE:/services/tasks/comments/{commentId}
   * @secure
   * @response `200` `void` OK
   */
  deleteCampaignComment = (commentId: string, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/services/tasks/comments/${commentId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-task-controller
   * @name UpdateCampaignCommentMessage
   * @request PATCH:/services/tasks/comments/{commentId}
   * @secure
   * @response `200` `CommentResponse` OK
   */
  updateCampaignCommentMessage = (
    commentId: string,
    data: CommentMessageRequest,
    params: RequestParams = {},
  ) =>
    this.request<CommentResponse, any>({
      path: `/services/tasks/comments/${commentId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags supplier-controller
   * @name ShowSupplier
   * @request GET:/services/suppliers/{supplierId}
   * @secure
   * @response `200` `SupplierDetailResponse` OK
   */
  showSupplier = (supplierId: string, params: RequestParams = {}) =>
    this.request<SupplierDetailResponse, any>({
      path: `/services/suppliers/${supplierId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags supplier-controller
   * @name DeleteSupplier
   * @request DELETE:/services/suppliers/{supplierId}
   * @secure
   * @response `200` `void` OK
   */
  deleteSupplier = (supplierId: string, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/services/suppliers/${supplierId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags supplier-controller
   * @name UpdateSupplier
   * @request PATCH:/services/suppliers/{supplierId}
   * @secure
   * @response `200` `SupplierDetailResponse` OK
   */
  updateSupplier = (
    supplierId: string,
    data: SupplierRequest,
    params: RequestParams = {},
  ) =>
    this.request<SupplierDetailResponse, any>({
      path: `/services/suppliers/${supplierId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-view-controller
   * @name GetServicesViewById
   * @summary Get Services View by ID
   * @request GET:/services/views/{viewId}
   * @secure
   * @response `200` `ServiceViewResponse` OK
   */
  getServicesViewById = (viewId: string, params: RequestParams = {}) =>
    this.request<ServiceViewResponse, any>({
      path: `/services/views/${viewId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-view-controller
   * @name GetHistory
   * @request GET:/services/views/history/{resourceId}
   * @secure
   * @response `200` `(AuditResponse)[]` OK
   */
  getHistory = (resourceId: string, params: RequestParams = {}) =>
    this.request<AuditResponse[], any>({
      path: `/services/views/history/${resourceId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-view-controller
   * @name ListViews
   * @request GET:/services/views/
   * @secure
   * @response `200` `(ServiceViewResponse)[]` OK
   */
  listViews = (params: RequestParams = {}) =>
    this.request<ServiceViewResponse[], any>({
      path: `/services/views/`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-task-controller
   * @name DownloadServiceTaskLayoutSketch
   * @summary Download Service Task Layout Sketch
   * @request GET:/services/tasks/{taskId}/layoutSketch/{documentId}
   * @secure
   * @response `200` `File` OK
   */
  downloadServiceTaskLayoutSketch = (
    taskId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<Blob, any>({
      path: `/services/tasks/${taskId}/layoutSketch/${documentId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-task-controller
   * @name DownloadServiceTaskLayoutSketchOriginal
   * @summary Download Service Task Layout Sketch Original
   * @request GET:/services/tasks/{taskId}/layoutSketch/{documentId}/original
   * @secure
   * @response `200` `File` OK
   */
  downloadServiceTaskLayoutSketchOriginal = (
    taskId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<Blob, any>({
      path: `/services/tasks/${taskId}/layoutSketch/${documentId}/original`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-task-controller
   * @name GetServiceTaskDocument
   * @request GET:/services/tasks/{taskId}/documents/{documentId}
   * @secure
   * @response `200` `File` OK
   */
  getServiceTaskDocument = (
    taskId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<File, any>({
      path: `/services/tasks/${taskId}/documents/${documentId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-task-controller
   * @name DeleteServiceTaskDocument
   * @request DELETE:/services/tasks/{taskId}/documents/{documentId}
   * @secure
   * @response `200` `ServiceTaskDocumentsResponse` OK
   */
  deleteServiceTaskDocument = (
    taskId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<ServiceTaskDocumentsResponse, any>({
      path: `/services/tasks/${taskId}/documents/${documentId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-task-controller
   * @name DownloadServiceTaskCommentDocument
   * @request GET:/services/tasks/{taskId}/comments/documents/{documentId}
   * @secure
   * @response `200` `File` OK
   */
  downloadServiceTaskCommentDocument = (
    taskId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<File, any>({
      path: `/services/tasks/${taskId}/comments/documents/${documentId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-task-controller
   * @name DownloadCampaignImage
   * @request GET:/services/tasks/{taskId}/campaignMonitor/{documentId}
   * @secure
   * @response `200` `File` OK
   */
  downloadCampaignImage = (
    taskId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<File, any>({
      path: `/services/tasks/${taskId}/campaignMonitor/${documentId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-task-controller
   * @name DeleteCampaignImage
   * @request DELETE:/services/tasks/{taskId}/campaignMonitor/{documentId}
   * @secure
   * @response `200` `CampaignMonitorPicturesResponse` OK
   */
  deleteCampaignImage = (
    taskId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<CampaignMonitorPicturesResponse, any>({
      path: `/services/tasks/${taskId}/campaignMonitor/${documentId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-task-controller
   * @name DownloadServiceTaskArtworkPreview
   * @summary Download Service Task Artwork Preview
   * @request GET:/services/tasks/{taskId}/artworkPreview/{documentId}
   * @secure
   * @response `200` `File` OK
   */
  downloadServiceTaskArtworkPreview = (
    taskId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<Blob, any>({
      path: `/services/tasks/${taskId}/artworkPreview/${documentId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-task-controller
   * @name DeleteServiceTaskArtworkPreview
   * @summary Delete Service Task Artwork Preview
   * @request DELETE:/services/tasks/{taskId}/artworkPreview/{documentId}
   * @secure
   * @response `200` `ServiceTaskResponse` OK
   */
  deleteServiceTaskArtworkPreview = (
    taskId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<ServiceTaskResponse, any>({
      path: `/services/tasks/${taskId}/artworkPreview/${documentId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-task-controller
   * @name DownloadArtworkMatchFile
   * @request GET:/services/tasks/{taskId}/artworkMatch/{documentId}
   * @secure
   * @response `200` `File` OK
   */
  downloadArtworkMatchFile = (
    taskId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<File, any>({
      path: `/services/tasks/${taskId}/artworkMatch/${documentId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-task-controller
   * @name DeleteArtworkMatchFile
   * @request DELETE:/services/tasks/{taskId}/artworkMatch/{documentId}
   * @secure
   * @response `200` `ArtworkMatchFilesResponse` OK
   */
  deleteArtworkMatchFile = (
    taskId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<ArtworkMatchFilesResponse, any>({
      path: `/services/tasks/${taskId}/artworkMatch/${documentId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-task-controller
   * @name DownloadArtworkFileForServiceTask
   * @summary Download artwork file for service task
   * @request GET:/services/tasks/{taskId}/artworkFiles/{documentId}
   * @secure
   * @response `200` `File` OK
   */
  downloadArtworkFileForServiceTask = (
    taskId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<Blob, any>({
      path: `/services/tasks/${taskId}/artworkFiles/${documentId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-task-controller
   * @name DownloadServiceTaskArtwork
   * @summary Download Service Task Artwork
   * @request GET:/services/tasks/{taskId}/artwork/{documentId}
   * @secure
   * @response `200` `File` OK
   */
  downloadServiceTaskArtwork = (
    taskId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<Blob, any>({
      path: `/services/tasks/${taskId}/artwork/${documentId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-task-controller
   * @name GetServiceTaskTodos
   * @summary Get confirm, daytime-images, and delivery-method todos for the current SERVICES user
   * @request GET:/services/tasks/todos
   * @secure
   * @response `200` `(TodoResponse)[]` OK
   */
  getServiceTaskTodos = (params: RequestParams = {}) =>
    this.request<TodoResponse[], any>({
      path: `/services/tasks/todos`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags service-task-controller
   * @name GetServiceTaskFilterValues
   * @summary Get Service Task Filter Values
   * @request GET:/services/tasks/filters
   * @secure
   * @response `200` `ServiceTaskFilterResponse` OK
   */
  getServiceTaskFilterValues = (params: RequestParams = {}) =>
    this.request<ServiceTaskFilterResponse, any>({
      path: `/services/tasks/filters`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-task-controller
   * @name DownloadCampaignCommentDocument
   * @request GET:/services/tasks/comments/{orderId}/documents/{documentId}
   * @secure
   * @response `200` `File` OK
   */
  downloadCampaignCommentDocument = (
    orderId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<File, any>({
      path: `/services/tasks/comments/${orderId}/documents/${documentId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-controller
   * @name GetHistory1
   * @request GET:/services/history/{serviceTaskId}
   * @secure
   * @response `200` `(AuditResponse)[]` OK
   */
  getHistory1 = (serviceTaskId: string, params: RequestParams = {}) =>
    this.request<AuditResponse[], any>({
      path: `/services/history/${serviceTaskId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags deployment-dashboard-controller
   * @name GetDeploymentDashboard
   * @summary Deployment dashboard for the selected day or period (Europe/Bucharest business days, both ends inclusive)
   * @request GET:/services/dashboard/deployment
   * @secure
   * @response `200` `DeploymentDashboardResponse` OK
   */
  getDeploymentDashboard = (
    query: {
      /** @format date */
      from: string;
      /** @format date */
      to: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<DeploymentDashboardResponse, any>({
      path: `/services/dashboard/deployment`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags service-task-controller
   * @name DeleteServiceTaskArtworkPreviewVersion
   * @summary Delete Service Task Artwork Preview Version
   * @request DELETE:/services/tasks/{taskId}/artworkPreview/{attachmentId}/versions/{versionId}
   * @secure
   * @response `200` `AttachmentResponse` OK
   */
  deleteServiceTaskArtworkPreviewVersion = (
    taskId: string,
    attachmentId: string,
    versionId: number,
    params: RequestParams = {},
  ) =>
    this.request<AttachmentResponse, any>({
      path: `/services/tasks/${taskId}/artworkPreview/${attachmentId}/versions/${versionId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags service-task-controller
   * @name DeleteServiceTaskArtwork
   * @summary Delete Service Task Artwork
   * @request DELETE:/services/tasks/{taskId}/artwork/{attachmentId}
   * @secure
   * @response `200` `ServiceTaskResponse` OK
   */
  deleteServiceTaskArtwork = (
    taskId: string,
    attachmentId: string,
    params: RequestParams = {},
  ) =>
    this.request<ServiceTaskResponse, any>({
      path: `/services/tasks/${taskId}/artwork/${attachmentId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
}
